module.exports = __webpack_public_path__ + "static/media/Ahmed.3221ee76.jpeg";